/**
 * 役所資料取得代行フォームの Zod スキーマ定義。
 * RealEstateDocumentFetchModal.tsx から抽出。
 */

import { z } from "zod";

/** フォームバリデーション用 Zod スキーマ */
export const realEstateDocumentFormSchema = z.object({
  address: z.string().min(1, "住所は必須です"),
  /** マンション名（任意）。依頼の一覧で物件を見分けるのに使う。 */
  buildingName: z
    .string()
    .max(255, "マンション名は255文字以内で入力してください")
    .optional(),
  chibanList: z
    .array(
      z.object({
        prefName: z.string(),
        location: z.string(),
        chibanAndKaokuNumber: z.string(),
      })
    )
    .min(1, "少なくとも1つの地番を入力してください"),
  kaokuNumberList: z
    .array(
      z.object({
        prefName: z.string(),
        location: z.string(),
        chibanAndKaokuNumber: z.string(),
      })
    )
    .optional(),
  selectedDocuments: z.array(z.string()).default([]),
  otherDocuments: z
    .array(z.string().max(200, "その他の書類は200文字以内で入力してください"))
    .optional(),
  sharedOwnerNames: z.record(z.string()).optional(),
  comment: z
    .string()
    .max(1000, "備考は1,000文字以内で入力してください")
    .optional(),
  needsPostalDelivery: z.boolean().optional(),
  postalAddress: z.string().optional(),
  documentLocations: z.record(z.string()).optional(),
  hearingItems: z.array(z.string()).optional(),
});

/** フォームデータの型定義 */
export type RealEstateDocumentFormData = z.infer<
  typeof realEstateDocumentFormSchema
>;
